import React, { useEffect, useState } from "react";
import { money } from "@/lib/api";
import { Flame, Heart } from "lucide-react";

export default function ActivityTicker({ supporters = [], donorsLast24h = 0 }) {
  const items = (supporters || []).filter((s) => s && s.name).slice(0, 12);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (items.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 3500);
    return () => clearInterval(t);
  }, [items.length]);

  if (!items.length && !donorsLast24h) return null;
  const s = items.length ? items[idx % items.length] : null;

  return (
    <div data-testid="activity-ticker" className="flex flex-wrap items-center gap-3 rounded-xl border border-ff-border bg-[#F3F4F6] px-4 py-2.5">
      {donorsLast24h > 0 && (
        <span data-testid="ticker-24h" className="inline-flex items-center gap-1.5 rounded-full bg-[#FEF2F2] px-2.5 py-1 text-xs font-bold text-ff-red">
          <Flame className="h-3.5 w-3.5" /> {donorsLast24h} donated in the last 24h
        </span>
      )}
      {s && (
        <span key={idx} data-testid="ticker-item" className="flex min-w-0 items-center gap-2 text-sm text-ff-dark transition-opacity duration-500">
          <Heart className="h-3.5 w-3.5 shrink-0 text-ff-green" />
          <span className="truncate">
            <span className="font-semibold text-ff-blue">{s.name}</span>
            {s.amount != null && <> donated <span className="font-semibold text-ff-green">{money(s.amount)}</span></>}
            {s.date && <span className="text-ff-medium"> · {new Date(s.date).toLocaleDateString("en-US", { month: "short", day: "numeric" })}</span>}
          </span>
        </span>
      )}
    </div>
  );
}
